module.exports = __webpack_public_path__ + "static/media/CustomError.769316f1.svg";